import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Select } from 'antd'
import css from './contact-mapping.css'

const { Option } = Select

const RemindersEmailAddressEntry = ({
  fEmails,
  isInvalid,
  isTopsAdmin,
  onInputChange,
  onSelect,
  validationError,
}) => (
  <div className={css.phoneOrEmailWrapper}>
    <span className={css.labelSmall}>Reminders email address</span>
    <Form.Item
      className={css.formItem}
      validateStatus={isInvalid ? 'error' : 'success'}
      help={isInvalid ? validationError : null}
    >
      <Input
        className={css.input}
        style={{ minWidth: '280px' }}
        value={fEmails[0]}
        name="fEmailStart"
        onChange={onInputChange}
        addonAfter={
          <Select
            style={{ width: '200px' }}
            name="fEmailEnd"
            value={fEmails[1]}
            onChange={onSelect}
          >
            <Option value="myappointment.guru">@myappointment.guru</Option>
            <Option value="appointmentreminders.topsortho.com">
              @appointmentreminders.topsortho.com
            </Option>
            {!isTopsAdmin && (
              <Option value="openchair.threadcommunication.com">
                @openchair.threadcommunication.com
              </Option>
            )}
            {!isTopsAdmin && (
              <Option value="reminders.threadcommunication.com">
                @reminders.threadcommunication.com
              </Option>
            )}
          </Select>
        }
      />
    </Form.Item>
  </div>
)

RemindersEmailAddressEntry.propTypes = {
  fEmails: PropTypes.arrayOf(PropTypes.string).isRequired,
  isInvalid: PropTypes.bool.isRequired,
  isTopsAdmin: PropTypes.bool.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  validationError: PropTypes.string.isRequired,
}

export default RemindersEmailAddressEntry



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/RemindersEmailAddressEntry.js